import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'intersection-observer';

import React from 'react';
import ReactDOM from 'react-dom';
import Root from './client/Root';
import * as serviceWorker from './serviceWorker';
import ReactGA from './ga';

if (!Element.prototype.toggleAttribute) {
    Element.prototype.toggleAttribute = function(name:string, force:boolean) {
        if(force !== void 0) force = !!force 
      
        if (this.hasAttribute(name)) {
            if (force) return true;  
            this.removeAttribute(name);
            return false;
        }

        if (force === false) return false;

        this.setAttribute(name, "");
        return true;
    };
}


ReactDOM.render(<Root />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
